export default {
  DOWNLOAD_START: 'Descargando... Espere…',
  DOWNLOAD_SUCCESS: 'Gracias Ahora puede cerrar esta ventana.'
}
